import React, { useMemo, useState } from "react";
import {
  BrowserRouter,
  Switch,
  Route,
} from "react-router-dom";

import OrganicShop from "./pages/OrganicShop";
import Shop from "./pages/Shop/Shop";
import About from './pages/About/About'
import Contact from "./pages/Contact/Contact";
import Login from "./pages/Auth/Login";
import Signup from "./pages/Auth/Signup";
import Cart from "./pages/Cart/Cart";
import { Product } from "./components/Products/ProductCard";

interface CartItem {
  product: Product;
  quantity: number;
}

const App: React.FC = () => {
    const [cart, setCart] = useState<CartItem[]>([]);
    const cartCount = useMemo(
      () =>
        cart.reduce(
          (total, item) =>
            total + item.quantity,
          0
        ),
      [cart]
    );

    const openCart = () => {
      // Cart page handles the actual cart.
    };

  return (
    <BrowserRouter>
      <Switch>

        {/* Home */}
        <Route
          exact
          path="/"
          component={OrganicShop}
        />

        {/* Shop */}
        <Route
          exact
          path="/shop"
          component={Shop}
        />

        <Route
          exact
          path="/about"
          component={About}
        />

        <Route
          exact
          path="/contact"
          component={Contact}
        />

         <Route
          exact
          path="/login"
          component={Login}
        />

        <Route
          exact
          path="/signup"
          component={Signup}
        />

         <Route path="/cart">
          <Cart
            cart={cart}
            setCart={setCart}
            cartCount={cartCount}
            onCartClick={openCart}
          />
        </Route>

      </Switch>
    </BrowserRouter>
  );
};

export default App;